export default {
  methods: {
    clickPreview: function() {
      document.querySelector('.gjs-pn-btn.fa.fa-eye').addEventListener('click', function() {
        let leftPanel = document.getElementById('panel__left');
        let pages = document.getElementById('pages');
        pages.insertBefore(leftPanel, pages.childNodes[0]);
      });
    },
    clickFullScreen: function() {
      /*document.querySelector('.gjs-pn-btn.fa.fa-arrows-alt').addEventListener('click', function() {
        let leftPanel = document.getElementById('panel__left');
        let gjs = document.getElementById('gjs');
        // Show  ( information panel,newInformation and dropdownSave )
        let information = document.getElementById('list-informations');
        let newInformation = document.getElementById('list-informations-new');
        let dropdownSave= document.getElementById('dropdown-save');
        gjs.insertBefore(dropdownSave, gjs.childNodes[0]);
        gjs.insertBefore(newInformation, gjs.childNodes[0]);
        gjs.insertBefore(information, gjs.childNodes[0]);

        //show slide-list-modal in fullscreen
        let slidelistmodal= document.getElementById('slide-list');
        gjs.insertBefore(slidelistmodal, gjs.childNodes[0]);
        gjs.insertBefore(leftPanel, gjs.childNodes[0]);
      });
    */
    },
    listenerFullScreen: function() {
      document.addEventListener('fullscreenchange', exitHandler);
      document.addEventListener('webkitfullscreenchange', exitHandler);
      document.addEventListener('mozfullscreenchange', exitHandler);
      document.addEventListener('MSFullscreenChange', exitHandler);

      function exitHandler() {
        if (
          !document.fullscreenElement &&
          !document.webkitIsFullScreen &&
          !document.mozFullScreen &&
          !document.msFullscreenElement
        ) {
          try {
            document.querySelector('.gjs-off-prv').click();
          } catch (error) {}
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinEvent.js